(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["downloads"]) return;
  try {
    
$(window).load(function() {
    $('#downloads').DataTable({
		"paging": false,
		"info": false,
		"searching": true,
        'columnDefs': [{
            'targets': 2, 
            'orderable': false, 
        }],
        language: {
            searchPlaceholder: "Søg navn eller varenummer...",
            search: ""
        },
	});
});

  } catch(e) { console.error(e); }
})();

})();
